export class SearchModelBase {
    projectionFields: string[] = [];
    skip: number = 0;
    limit: number = 10;
    totalItems: number = 0;
}


// WEBPACK FOOTER //
// ./src/app/models/utils/SearchModelBase.model.ts